import { Fragment } from "react";
import { GoogleMap, useJsApiLoader, Marker } from '@react-google-maps/api'
const containerStyle = {
  width: 'auto',
  height: '500px',
}

export default function Mapa(props) {

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: 'AIzaSyDRxH40vVGS8IKwWokZyE9bqKcu8Xo8TW4',
  })

  function gotodir(e, pos) {
    window.open(`https://www.google.com/maps/dir/?api=1&destination=${pos.lat},${pos.lng}`, '_blank', 'noreferrer');
  }

  return isLoaded ? (
    <div className={props.className}>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={props.center}
        zoom={14}
      >
        
        {/* Child components, such as markers, info windows, etc. */}
       

          {props.marks.map((m, im) => (
            <Fragment key={im}>
              <Marker
                position={m.pos}
                icon={props.icon}
                onClick={(e) => { gotodir(e, m.pos) }}
              >
              </Marker>
              {/* <InfoWindow position={m.pos}>
                <div>
                  {m.info}
                </div>
              </InfoWindow> */}
            </Fragment>
          ))}

       
      </GoogleMap>
    </div>
  ) : (
    <div {...props.className}></div>
  )
}
